//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import styled, { css } from 'styled-components';

export const InternalButtonSpinner = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacings[2]} ${theme.spacings[3]};
    padding-left: ${theme.spacings[0]};
    svg {
      margin-left: ${theme.spacings[1]};
      height: ${theme.fontSizes[3]};
      width: ${theme.fontSizes[3]};
    }
  `,
);
